<script setup lang="ts">
import { computed } from 'vue'
import { useUIStore } from '@/stores/ui.store'

const ui = useUIStore()
const isOpen = computed(() => ui.sidebarOpen || ui.filtersOpen)
</script>

<template>
  <div
    id="backdrop"
    class="backdrop"
    :class="{ 'is-open': isOpen }"
    @click="ui.closeDrawers()"
  ></div>
</template>
